/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "../actions/actionTypes";
import cloneDeep from "lodash/cloneDeep";

// initialState
const initialState = {
  isSignedIn: false,
  accountId: null,
  idToken: null,
  profileName: null,
};

/**
 * Capture actions dispatched and modify state accordingly
 * @param {*} state -> updated state
 * @param {*} action -> type of action dispatched
 * modify authentication data in store
 */
const Auth = (state = initialState, action) => {
  let updatedState = cloneDeep(state);
  switch (action.type) {
    // set authentication data in state
    case actionTypes.SET_AUTH_DATA:
      updatedState.isSignedIn = action.auth.isSignedIn;
      updatedState.accountId = action.auth.accountId;
      updatedState.idToken = action.auth.idToken;
      updatedState.profileName = action.auth.profileName;
      return updatedState;

    // set/update id token in state
    case actionTypes.AUTH_SET_TOKEN:
      updatedState.idToken = action.idToken;
      return updatedState;

    default:
      return state;
  }
};

export default Auth;
